import React, { Fragment, ReactElement } from 'react';
import cn from 'utils/cn';

export type TActionButtonsContainerProps = {
  actionButtons: ReactElement<any>[];
  actionButtonsClassName?: string;
};

const ActionButtonsContainer: React.FC<TActionButtonsContainerProps> = ({
  actionButtons,
  actionButtonsClassName = 'bg-shade-dark-25',
}): ReactElement<any> => {
  return (
    <div className={cn('tw:flex', actionButtonsClassName)} data-testid="action-buttons-container">
      {actionButtons.map((item, index) => (
        <Fragment key={index}>{item}</Fragment>
      ))}
    </div>
  );
};

export default ActionButtonsContainer;
